'use client';

import React, { useState } from 'react';
import styles from '@/styles/Home.module.css';

export function LoginForm(props: { next: string }) {
  const [error, setError] = useState<string>();
  const [pending, setPending] = useState(false);

  const onSubmit: React.FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    setPending(true);
    setError(undefined);
    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: formData.get('username'),
          password: formData.get('password'),
        }),
      });
      if (response.ok) {
        // Keep the fragment: on a room link it holds the E2EE passphrase.
        window.location.assign(props.next + window.location.hash);
        return;
      }
      if (response.status === 401) {
        setError('Incorrect username or password.');
      } else if (response.status === 429) {
        const minutes = Math.ceil(Number(response.headers.get('Retry-After') ?? 60) / 60);
        setError(`Too many attempts. Try again in ${minutes} minute${minutes === 1 ? '' : 's'}.`);
      } else {
        setError('Sign-in failed. Check the server logs.');
      }
    } catch {
      setError('Could not reach the server.');
    }
    setPending(false);
  };

  return (
    <form className={styles.tabContent} onSubmit={onSubmit}>
      <input
        name="username"
        type="text"
        placeholder="Username"
        autoComplete="username"
        autoCapitalize="none"
        spellCheck={false}
        autoFocus
        required
      />
      <input
        name="password"
        type="password"
        placeholder="Password"
        autoComplete="current-password"
        required
      />
      {error && (
        <p role="alert" style={{ margin: 0, color: '#ff6352' }}>
          {error}
        </p>
      )}
      <button
        style={{ marginTop: '0.5rem', width: '100%' }}
        className="lk-button"
        type="submit"
        disabled={pending}
      >
        {pending ? 'Signing in…' : 'Sign in'}
      </button>
    </form>
  );
}
